module.exports = __webpack_public_path__ + "img/apc_head_logo.a75088fd.svg";